const assignBox = {
  form: {
    generalForm: {
      header: 'הגדרות מתקדמות לציוותי נהגים',
      actions: {
        saveCheckBox: 'שמור כברירת מחדל',
      },
      formBtns: {
        btnCancel: 'בטל',
        btnAssign: 'צוות',
      },
      inputAssignBy: 'סוג ציוות',
      inputActualDrivers: 'אמיתי',
      inputVirtualDrivers: 'וירטואלי',
    },
    actualForm: {
      information: {
        inputOnlyDrivers: 'התעלם ממשמרות נהג',
        inputMaxShiftsHours: 'מקסימום שעות למשמרת',
        defaultCarLocation: 'מיקום רכב ברירת מחדל',
        inputMaxPrice: 'מחיר מקסימלי',
        inputFillVirtual: 'מלא הזמנות לא מצוותות עם נהגים וירטואליים',
        inputMaxTrips: 'מקסימום נסיעות',
        inputAssignFairly: 'צוות באופן שווה',
      },
      validations: {
        maxShifts: {
          require: 'נדרש',
          min: 'לפחות 1',
          max: 'מקסימום 24',
        },
        carLocation: {
          require: 'נדרש',
        },
        fillVirtual: {
          require: 'נדרש',
        },
        maxTrips: {
          require: 'נדרש',
        },
        maxPrice: {
          require: 'נדרש',
        },
        default: {
          require: 'נדרש',
        },
      },
    },
    virtualForm: {
      information: {
        inputUpTo: 'עד',
        inputDrivers: 'נהגים',
        inputMaxSeats: 'מקסימום מושבים',
        inputMaxShiftsHours: 'מקסימום שעות למשמרת',
        defaultCarLocation: 'מיקום רכב ברירת מחדל',
        inputAssignFairly: 'צוות באופן שווה',
      },
      validations: {
        limitDrivers: {
          require: 'נדרש',
        },
        carLocation: {
          require: 'נדרש',
        },
        maxShifts: {
          require: 'נדרש',
          min: 'לפחות 1',
          max: 'מקסימום 24',
        },
        default: {
          require: 'נדרש',
        },
      },
    },
    errorsMessages: {
      updateCar: 'עדכון מיקום הרכב נכשל',
    }
  },
};

export default assignBox;
